import { useQuery } from "@tanstack/react-query";

import { authStoreService } from "@/services/auth";

/**
 * Fetch current store session via GET /auth/store/me.
 * Trình duyệt tự gửi HttpOnly accessToken cookie.
 * Nếu accessToken hết hạn → axios interceptor tự refresh → retry.
 * Nếu refresh cũng fail → interceptor dispatch auth:logout event.
 *
 * KHÔNG CẦN check cookie để enable/disable query vì cookies là HttpOnly.
 * Query LUÔN chạy khi component mount → server sẽ trả 200 hoặc 401.
 */
export const useStoreMe = () => {
  return useQuery({
    queryKey: ["store", "me"],
    queryFn: () => authStoreService.getMe(),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    retry: (failureCount, error) => {
      // Don't retry on 401 - interceptor already handled refresh
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const status = (error as any)?.response?.status;
      if (status === 401) return false;
      return failureCount < 2;
    },
    meta: { skipGlobalError: true },
  });
};
